import { io } from 'socket.io-client';

const SOCKET_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

export const socket = io(SOCKET_URL, {
  autoConnect: false,
  transports: ['websocket', 'polling'],
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  timeout: 20000
});

let currentUserId = null;

socket.on('connect', () => {
  console.log('Socket connected');
  if (currentUserId) {
    socket.emit('join_room', { room: currentUserId });
  }
});

socket.on('disconnect', (reason) => {
  console.log('Socket disconnected:', reason);
});

socket.on('connect_error', (error) => {
  console.log('Socket connection error:', error.message);
});

export const connectSocket = (userId) => {
  currentUserId = userId;
  if (!socket.connected) {
    socket.connect();
  } else {
    socket.emit('join_room', { room: userId });
  }
};

export const disconnectSocket = () => {
  currentUserId = null;
  if (socket.connected) {
    socket.disconnect();
  }
};

export default socket;
